import { useEffect } from "react";
import { useParams, useLocation } from "wouter";
import { AlertCircle } from "lucide-react";

export default function PaiementFailed() {
  const { paiementId } = useParams();
  const [, setLocation] = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setLocation(`/paiement/${paiementId}`), 2500);
    return () => clearTimeout(t);
  }, [paiementId, setLocation]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <div className="w-24 h-24 bg-[#F8E2DF] rounded-full flex items-center justify-center mb-6 animate-pulse">
        <AlertCircle size={48} className="text-[#C84B3F]" />
      </div>
      <h1 className="text-[40px] sm:text-[48px] leading-tight [font-family:'Cormorant_Garamond',serif] font-bold text-navy mb-4">
        Paiement échoué
      </h1>
      <p className="text-lg text-navy/60">
        Redirection vers les détails du paiement…
      </p>
    </div>
  );
}
